import React, { useState, useEffect } from "react";
import { motion, AnimatePresence, useScroll, useMotionValueEvent } from "framer-motion";
import { HashLink as NavLink } from "react-router-hash-link";
import "./style.css";

const REGISTER_URL =
  "https://unstop.com/internships/campus-ambassador-internship-udghosh-1728653?lb=use17Prx&utm_medium=Share&utm_source=WhatsApp";

const links = [
  { label: "Home",             to: "#" },
  { label: "Responsibilities", to: "#featured" },
  { label: "Rewards",          to: "#rewards" },
  { label: "Testimonials",     to: "#testimonials" },
  { label: "Gallery",          to: "#gallery" },
  { label: "FAQs",             to: "#faqs" },
  { label: "Sponsors",         to: "#sponsors" },
  { label: "Contact Us",       to: "#Contacts" },
];

const Navbar2 = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, "change", (latest) => {
    const previous = scrollY.getPrevious();
    if (latest > 40) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
    
    if (latest > 150 && latest > previous && !isOpen) {
      setHidden(true);
    } else {
      setHidden(false);
    }
  });

  const toggle = () => setIsOpen((prev) => !prev);
  const close  = () => setIsOpen(false);

  return (
    <>
      {/* ── Fixed top bar ── */}
      <motion.header
        className={`udg-navbar${scrolled ? " udg-navbar--scrolled" : ""}`}
        variants={{
          visible: { opacity: 1, y: 0 },
          hidden: { opacity: 0, y: "-100%" },
        }}
        animate={hidden ? "hidden" : "visible"}
        transition={{ duration: 0.35, ease: "easeInOut" }}
      >
        {/* Logo */}
        <a
          href="https://udghosh.org.in/"
          className="udg-navbar__logo"
          target="_blank"
          rel="noreferrer"
          aria-label="Udghosh home"
        >
          <img src="/logonew.png" alt="Udghosh logo" />
        </a>

        {/* Desktop links */}
        <nav className="udg-navbar__links" aria-label="Main navigation">
          {links.map((l) => (
            <NavLink
              key={l.label}
              to={l.to}
              smooth
              duration={500}
              className="udg-navbar__link"
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        {/* Desktop CTA */}
        <a
          href={REGISTER_URL}
          className="udg-btn udg-navbar__cta"
          target="_blank"
          rel="noreferrer"
          id="navbar-register-btn"
        >
          Register
        </a>

        {/* Hamburger (mobile) */}
        <button
          className="udg-navbar__burger"
          onClick={toggle}
          aria-label="Toggle menu"
          aria-expanded={isOpen}
        >
          {isOpen ? (
            <svg width="20" height="20" viewBox="0 0 384 512" fill="currentColor">
              <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
            </svg>
          ) : (
            <svg width="22" height="22" viewBox="0 0 448 512" fill="currentColor">
              <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" />
            </svg>
          )}
        </button>
      </motion.header>

      {/* ── Mobile drawer ── */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="udg-drawer"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          >
            <nav className="udg-drawer__links" aria-label="Mobile navigation">
              {links.map((l) => (
                <NavLink
                  key={l.label}
                  to={l.to}
                  smooth
                  duration={500}
                  className="udg-drawer__link"
                  onClick={close}
                >
                  {l.label}
                </NavLink>
              ))}
            </nav>
            <a
              href={REGISTER_URL}
              className="udg-btn udg-btn-filled udg-drawer__cta"
              target="_blank"
              rel="noreferrer"
              onClick={close}
            >
              Register Now
            </a>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Backdrop */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="udg-drawer-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={close}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar2;
